import { LinkBreak1Icon, PauseIcon, PlayIcon } from '@radix-ui/react-icons';
import { Heading, Text } from '@radix-ui/themes';
import { BlinkerMode } from 'enums/streaming';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useContext } from 'react';
import { StreamingContext } from './context';

export const Blinker = () => {
  const { lastFrame, paused, togglePaused } = useContext(StreamingContext);

  const mode = (() => {
    if (paused) {
      return BlinkerMode.Paused;
    }

    if (!lastFrame?.buffer) {
      // haven't received any frames yet
      return BlinkerMode.Disconnected;
    }

    if (lastFrame.received_timestamp === undefined) {
      // shouldn't trigger
      return BlinkerMode.Disconnected;
    }

    if (lastFrame.received_timestamp + 3_000 < Date.now()) {
      // older than 3s
      return BlinkerMode.Disconnected;
    }

    return BlinkerMode.Live;
  })();

  const label = (() => {
    switch (mode) {
      case BlinkerMode.Paused: {
        return 'PAUSED';
      }

      case BlinkerMode.Live: {
        return 'LIVE';
      }

      case BlinkerMode.Disconnected:
      default: {
        return 'CONNECTING...';
      }
    }
  })();

  const color = (() => {
    switch (mode) {
      case BlinkerMode.Paused: {
        return undefined;
      }

      case BlinkerMode.Live: {
        return RADIX.COLOR.SUCCESS;
      }

      case BlinkerMode.Disconnected:
      default: {
        return RADIX.COLOR.WARNING;
      }
    }
  })();

  const icon = (() => {
    switch (mode) {
      case BlinkerMode.Paused: {
        return <PauseIcon />;
      }

      case BlinkerMode.Live: {
        return <PlayIcon />;
      }

      case BlinkerMode.Disconnected:
      default: {
        return <LinkBreak1Icon />;
      }
    }
  })();

  return (
    <Heading
      className="blinker cursor-pointer"
      color={color}
      size={RADIX.HEADING.SIZE.MD}
      onClick={() => togglePaused()}
    >
      <Text className={mode === BlinkerMode.Live ? 'animate-blink' : undefined}>
        {icon}&nbsp;{label}
      </Text>
    </Heading>
  );
};
